var path = 'app/common/ui/modals/faq.tpl.html';
var html = "<div class=\"modal-close-icon\" ng-click=\"$modal.close()\">\n  <i class=\"fa fa-close\"></i>\n</div>\n<faq></faq>\n<fd-form-button\n  btn-primary=\"true\"\n  ng-click=\"$modal.close()\"\n  label=\"{{'button.close' | translate}}\"\n  class=\"pull-right\"\n></fd-form-button>\n";
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/ui/modals/faq.tpl.html
// module id = 1608
// module chunks = 0